export default __webpack_public_path__ + "static/media/copy_black.c084890b.svg";